import { NetworkError } from 'lib/errors';
import {
  ApiResponseAuth,
  AuthenticationPayload,
  AuthState,
  User,
  UserOrganisationNew,
} from 'store/auth/types';
import { ErrorState } from 'store/error/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

export const RESET_DEV = createAction('@APP/RESET_DEV')();
export const RESET_DEV_DATA = createAction('@APP/RESET_DEV_DATA')();

export const doAuthShowAuthModal = createAction('doShowSignInModal')<{
  actionAfterAuth: ErrorState['onClear'] | undefined;
}>();

export const doAuthHideAuthModal = createAction('doAuthHideAuthModal')();

export const UPDATE_USER = createAction('@AUTH/UDPATE_USER')<User>();

export const doUserSetUrlToken = createAction('@doUserSetUrlToken')<string>();

export const UPDATE_USER_EMAIL = createAction('@AUTH/UDPATE_USER_EMAIL')<
  User['email']
>();

export const UPDATE_USER_OFA = createAction('@AUTH/UPDATE_USER_OFA')<
  User['ofa']
>();

export const UPDATE_USER_NAME = createAction('@AUTH/UPDATE_USER_NAME')<
  User['name']
>();

export const UPDATE_USER_TFA = createAction('@AUTH/UPDATE_USER_TFA')<
  User['tfa']
>();

export const UPDATE_USER_AVATAR = createAction('@AUTH/UDPATE_USER_AVATAR')<
  User['avatar'] | null
>();

export const RESET_AUTH_STEP = createAction('@AUTH/RESET_AUTH_STEP')();

export const AUTHENTICATE = createAsyncAction(
  '@AUTH/AUTHENTICATE.REQUEST',
  '@AUTH/AUTHENTICATE.SUCCESS',
  '@AUTH/AUTHENTICATE.FAIL',
)<AuthenticationPayload, ApiResponseAuth, NetworkError>();

export const REQUEST_PASSWORD_RESET = createAsyncAction(
  '@AUTH/REQUEST_PASSWORD_RESET.REQUEST',
  '@AUTH/REQUEST_PASSWORD_RESET.SUCCESS',
  '@AUTH/REQUEST_PASSWORD_RESET.FAIL',
)<undefined, ApiResponseAuth, NetworkError>();

export const SIGN_OUT = createAsyncAction(
  '@AUTH/SIGN_OUT.REQUEST',
  '@AUTH/SIGN_OUT.SUCCESS',
  'NA',
)<undefined, undefined, undefined>();

export const doSettingOrganisationSelectStart = createAction(
  '@doSettingOrganisationSelectStart',
)();
export const doUserOrganisationSet = createAction('@doUserOrganisationSet')<{
  organisation: UserOrganisationNew | null;
}>();
export const doSettingOrganisationSelect = createAction(
  '@doSettingOrganisationSelect',
)<{ id: string }>();

export const UPDATE_USER_ORGANISATIONS = createAction(
  '@UPDATE_USER_ORGANISATIONS',
)<Record<string, AuthState['organisations'][string]>>();

export const doAuthSetSignInAs = createAction(
  '@auth/doAuthSetSignInAs',
)<string>();
